import React from "react";

const SuspensionModal = ({
  userName,
  userType,
  statusText,
  reason,
  decision,
  onClose,
}) => {
  return (
    <div className="suspension-modal-overlay">
      <div className="suspension-modal">
        {/* Header */}
        <div className="suspension-modal__header">
          <div className="suspension-modal__title">
            <span className="suspension-modal__icon">✓</span>
            <span>User {statusText}</span>
          </div>
          <button className="suspension-modal__close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="suspension-modal__content">
          {/* User Details Section */}
          <div className="suspension-modal__section">
            <h3 className="suspension-modal__section-title">
              <span className="suspension-modal__section-icon">👤</span>
              User Details
            </h3>
            <div className="suspension-modal__details">
              <div className="suspension-modal__detail-row">
                <span className="suspension-modal__detail-label">
                  Username:
                </span>
                <span className="suspension-modal__detail-value">
                  {userName}
                </span>
              </div>
              <div className="suspension-modal__detail-row">
                <span className="suspension-modal__detail-label">Type:</span>
                <span className="suspension-modal__detail-value">
                  {userType}
                </span>
              </div>
              <div className="suspension-modal__detail-row">
                <span className="suspension-modal__detail-label">Status:</span>
                <span
                  className={`suspension-modal__detail-value suspension-modal__status--${decision === "suspended" ? "suspended" : "unsuspended"}`}
                >
                  ● {statusText}
                </span>
              </div>
            </div>
          </div>

          {/* Reason Section */}
          <div className="suspension-modal__section">
            <h3 className="suspension-modal__section-title">
              <span className="suspension-modal__section-icon">⚠️</span>
              Reason for Action
            </h3>
            <div className="suspension-modal__reason">
              {reason || "No reason provided"}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="suspension-modal__footer">
          <button className="suspension-modal__btn-ok" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspensionModal;
